import classNames from 'classnames';
import * as bd from 'react-basic-design';
import { useNavigate } from 'react-router-dom';
import SvgArrowBackIos from '../../assets/icons/ArrowBackIos';
import { T } from '../basic/text';
import { CSSProperties } from 'react';

interface PageNavbarProps {
    title?: string | React.ReactNode;
    subtitle?: string | React.ReactNode;
    controls?: string | React.ReactNode;
    className?: string;
    style?: object;
    titleTextColor?: string;
    onGoBack?: string | object;
}

export const PageNavbar: React.FC<PageNavbarProps> = ({
    title,
    subtitle,
    controls,
    className,
    style,
    titleTextColor,
    onGoBack,
}) => {
    const navigate = useNavigate();
    let titleClassNames = 'fw-bold m-0';
    if (titleTextColor) {
        titleClassNames = titleClassNames + ` ${titleTextColor}`;
    } else {
        titleClassNames = titleClassNames + ' text-primary';
    }
    // const is_link_back = typeof onGoBack === "string";

    const onGoBackHandler = () => {
        if (typeof onGoBack == 'function') {
            onGoBack();
            return;
        }
        if (typeof onGoBack === 'string') {
            navigate(onGoBack);
            return;
        }
        navigate('/home');
    };

    const flex_style: CSSProperties = { ...style, minHeight: 40 };

    return (
        <>
            <bd.Flex
                className={classNames('test-page-navbar d-flex py-3 m-0 ', className)}
                style={flex_style}
                align="center"
                wrap
            >
                {onGoBack && (
                    <div className="m-e-2">
                        <bd.Button
                            variant="icon"
                            className="rtl-rotate-180"
                            onClick={onGoBackHandler}
                            type="button"
                            disableRipple
                        >
                            <SvgArrowBackIos />
                        </bd.Button>
                    </div>
                )}

                <bd.Flex vertical wrap>
                    <T as="h4" className={titleClassNames}>
                        {title}
                    </T>
                    {subtitle && (
                        <T as="h6" className="text-muted m-0 pt-2">
                            {subtitle}
                        </T>
                    )}
                </bd.Flex>

                <div className="m-s-auto">{controls}</div>
            </bd.Flex>
        </>
    );
};
